<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-th-list"></i>
        {{ $t('CHANNEL_SETTINGS_CATEGORY_SETTINGS_TITLE') }}:
      </h5>
    </div>

    <div class="card-body">
      <loading :active.sync="loading" :is-full-page="false"></loading>
      <v-select :options="availableCategories"
                label="name"
                :multiple="true"
                :searchable="true"
                :closeOnSelect="false"
                v-model="settings.categories"
                :reduce="category => category.id"
                v-if="availableCategories"></v-select>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';

import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';

const CategoryRepository = RepositoryFactory.get('categories');

export default {
  name: 'CategorySettings',
  components: { Loading },
  data() {
    return {
      loading: true,
      availableCategories: null,
    };
  },
  async mounted() {
    await this.fetchCategories();
  },
  methods: {
	    /**
       * Fetches all categories.
       *
	     * @returns {Promise<void>}
	     */
    async fetchCategories() {
      await CategoryRepository.list().then((res) => {
        this.availableCategories = res.data.list;
        this.loading = false;
      });
    },
  },
  computed: {
    settings() {
      return this.$store.getters.getChannelSettings;
    },
  },
};
</script>

<style scoped>

</style>
